import React from "react";
import { useParams } from "react-router-dom";
import PageBanner from "../commoncomponents/Pagebanner";

// Packing Details Component
function PackingDetails() {
  return (
    <div className="container my-5" data-aos="fade-up">
      <h2 className="text-center mb-4 custom-font">WALL TILES</h2>
      <div className="table-responsive">
        <table className="table table-bordered table-hover text-center align-middle">
          <thead className="table-dark">
            <tr>
              <th>Sr. No.</th>
              <th>Size (mm)</th>
              <th>Size (cm)</th>
              <th>Size (inch)</th>
              <th>Thickness (mm)</th>
              <th>Pcs/Box</th>
              <th>Box Weight (kg)</th>
              <th>Coverage (sq. ft.)</th>
              <th>Coverage (sq. mtr.)</th>
              <th>Box/Pallet</th>
              <th>Pallet Weight (kg)</th>
              <th>Pallet/Container</th>
              <th>Box/Container</th>
              <th>Sq. Mtr./Container</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>200×300</td>
              <td>20×30</td>
              <td>8×12</td>
              <td>5.5</td>
              <td>16</td>
              <td>9.5</td>
              <td>10.32</td>
              <td>0.96</td>
              <td>120</td>
              <td>1150</td>
              <td>24</td>
              <td>2880</td>
              <td>2764.8</td>
            </tr>
            <tr>
              <td>2</td>
              <td>250×375</td>
              <td>25×37.5</td>
              <td>10×15</td>
              <td>7</td>
              <td>8</td>
              <td>9</td>
              <td>8.07</td>
              <td>0.75</td>
              <td>135</td>
              <td>1260</td>
              <td>22</td>
              <td>2970</td>
              <td>2228</td>
            </tr>
            <tr>
              <td>4</td>
              <td>250×750</td>
              <td>25×75</td>
              <td>10×30</td>
              <td>9.00</td>
              <td>5</td>
              <td>16</td>
              <td>10.08</td>
              <td>0.937</td>
              <td>64</td>
              <td>1050</td>
              <td>26</td>
              <td>1664</td>
              <td>1559.17</td>
            </tr>
            <tr>
              <td>5</td>
              <td>300×450</td>
              <td>30×45</td>
              <td>12×18</td>
              <td>8</td>
              <td>6</td>
              <td>11</td>
              <td>8.72</td>
              <td>0.81</td>
              <td>108</td>
              <td>1200</td>
              <td>23</td>
              <td>2484</td>
              <td>2012.04</td>
            </tr>
            <tr>
              <td>6</td>
              <td>300×600</td>
              <td>30×60</td>
              <td>12×24</td>
              <td>9.00</td>
              <td>5</td>
              <td>14</td>
              <td>9.68</td>
              <td>0.90</td>
              <td>90</td>
              <td>1280</td>
              <td>22</td>
              <td>1980</td>
              <td>1782.00</td>
            </tr>
            <tr>
              <td>7</td>
              <td>300×300</td>
              <td>30×30</td>
              <td>12×12</td>
              <td>8.00</td>
              <td>9</td>
              <td>11</td>
              <td>8.71</td>
              <td>0.81</td>
              <td>108</td>
              <td>1260</td>
              <td>22</td>
              <td>2376</td>
              <td>1924.56</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="container my-5" data-aos="fade-up">
        <h2 className="text-center mb-4 custom-font">FLOOR TILES</h2>
        <div className="table-responsive">
          <table className="table table-bordered table-hover text-center align-middle">
            <thead className="table-dark">
              <tr>
                <th>Sr. No.</th>
                <th>Size (mm)</th>
                <th>Size (cm)</th>
                <th>Size (inch)</th>
                <th>Thickness (mm)</th>
                <th>Pcs/Box</th>
                <th>Box Weight (kg)</th>
                <th>Coverage (sq. ft.)</th>
                <th>Coverage (sq. mtr.)</th>
                <th>Box/Pallet</th>
                <th>Pallet Weight (kg)</th>
                <th>Pallet/Container</th>
                <th>Box/Container</th>
                <th>Sq. Mtr./Container</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>300×300</td>
                <td>30×30</td>
                <td>12×12</td>
                <td>7</td>
                <td>11</td>
                <td>13.7</td>
                <td>10.65</td>
                <td>0.99</td>
                <td>108</td>
                <td>1470</td>
                <td>19</td>
                <td>2052</td>
                <td>2031.8</td>
              </tr>
              <tr>
                <td>2</td>
                <td>396×396</td>
                <td>39.6×39.6</td>
                <td>16×16</td>
                <td>8</td>
                <td>6</td>
                <td>15.7</td>
                <td>10</td>
                <td>0.93</td>
                <td>84</td>
                <td>1320</td>
                <td>21</td>
                <td>1764</td>
                <td>1651.1</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="container my-5" data-aos="fade-up">
        <h2 className="text-center mb-4 custom-font">
          VITRIFIED PARKING TILES
        </h2>
        <div className="table-responsive">
          <table className="table table-bordered table-hover text-center align-middle">
            <thead className="table-dark">
              <tr>
                <th>Sr. No.</th>
                <th>Size (mm)</th>
                <th>Size (cm)</th>
                <th>Size (inch)</th>
                <th>Thickness (mm)</th>
                <th>Pcs/Box</th>
                <th>Box Weight (kg)</th>
                <th>Coverage (sq. ft.)</th>
                <th>Coverage (sq. mtr.)</th>
                <th>Box/Pallet</th>
                <th>Pallet Weight (kg)</th>
                <th>Pallet/Container</th>
                <th>Box/Container</th>
                <th>Sq. Mtr./Container</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>300×300</td>
                <td>30×30</td>
                <td>12×12</td>
                <td>7</td>
                <td>11</td>
                <td>13.7</td>
                <td>10.65</td>
                <td>0.99</td>
                <td>108</td>
                <td>1470</td>
                <td>19</td>
                <td>2052</td>
                <td>2031.8</td>
              </tr>
              <tr>
                <td>2</td>
                <td>396×396</td>
                <td>39.6×39.6</td>
                <td>16×16</td>
                <td>8</td>
                <td>6</td>
                <td>15.7</td>
                <td>10</td>
                <td>0.93</td>
                <td>84</td>
                <td>1320</td>
                <td>21</td>
                <td>1764</td>
                <td>1651.1</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="container my-5" data-aos="fade-up">
        <h2 className="text-center mb-4 custom-font">
          POLISHED PORCELAIN TILES
        </h2>
        <div className="table-responsive">
          <table className="table table-bordered table-hover text-center align-middle">
            <thead className="table-dark">
              <tr>
                <th>Sr. No.</th>
                <th>Size (mm)</th>
                <th>Size (cm)</th>
                <th>Size (inch)</th>
                <th>Thickness (mm)</th>
                <th>Pcs/Box</th>
                <th>Box Weight (kg)</th>
                <th>Coverage (sq. ft.)</th>
                <th>Coverage (sq. mtr.)</th>
                <th>Box/Pallet</th>
                <th>Pallet Weight (kg)</th>
                <th>Pallet/Container</th>
                <th>Box/Container</th>
                <th>Sq. Mtr./Container</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>600×600 </td>
                <td>60×60 </td>
                <td>24×24 </td>
                <td>8</td>
                <td>4</td>
                <td>25</td>
                <td>15.5</td>
                <td>1.44</td>
                <td>40</td>
                <td>1020</td>
                <td>27</td>
                <td>1080</td>
                <td>1555</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="container my-5" data-aos="fade-up">
        <h2 className="text-center mb-4 custom-font">
          DOUBLE CHARGE PORCELAIN TILES
        </h2>
        <div className="table-responsive">
          <table className="table table-bordered table-hover text-center align-middle">
            <thead className="table-dark">
              <tr>
                <th>Sr. No.</th>
                <th>Size (mm)</th>
                <th>Size (cm)</th>
                <th>Size (inch)</th>
                <th>Thickness (mm)</th>
                <th>Pcs/Box</th>
                <th>Box Weight (kg)</th>
                <th>Coverage (sq. ft.)</th>
                <th>Coverage (sq. mtr.)</th>
                <th>Box/Pallet</th>
                <th>Pallet Weight (kg)</th>
                <th>Pallet/Container</th>
                <th>Box/Container</th>
                <th>Sq. Mtr./Container</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>600×600</td>
                <td>60×60</td>
                <td>24×24</td>
                <td>8.5</td>
                <td>4</td>
                <td>27</td>
                <td>15.5</td>
                <td>1.44</td>
                <td>40</td>
                <td>1100</td>
                <td>25</td>
                <td>1000</td>
                <td>1440</td>
              </tr>
              <tr>
                <td>2</td>
                <td>800×800</td>
                <td>80×80</td>
                <td>32×32</td>
                <td>9.5</td>
                <td>3</td>
                <td>38</td>
                <td>20.66</td>
                <td>1.92</td>
                <td>32</td>
                <td>1225</td>
                <td>22</td>
                <td>640</td>
                <td>1351.68</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="container my-5" data-aos="fade-up">
        <h2 className="text-center mb-4 custom-font">
          FULL BODY PORCELAIN TILES
        </h2>
        <div className="table-responsive">
          <table className="table table-bordered table-hover text-center align-middle">
            <thead className="table-dark">
              <tr>
                <th>Sr. No.</th>
                <th>Size (mm)</th>
                <th>Size (cm)</th>
                <th>Size (inch)</th>
                <th>Thickness (mm)</th>
                <th>Pcs/Box</th>
                <th>Box Weight (kg)</th>
                <th>Coverage (sq. ft.)</th>
                <th>Coverage (sq. mtr.)</th>
                <th>Box/Pallet</th>
                <th>Pallet Weight (kg)</th>
                <th>Pallet/Container</th>
                <th>Box/Container</th>
                <th>Sq. Mtr./Container</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>600×600</td>
                <td>60×60</td>
                <td>24×24</td>
                <td>9</td>
                <td>4</td>
                <td>28</td>
                <td>15.5</td>
                <td>1.44</td>
                <td>40</td>
                <td>1140</td>
                <td>24</td>
                <td>960</td>
                <td>1382</td>
              </tr>
              <tr>
                <td>2</td>
                <td>600×1200</td>
                <td>60×120</td>
                <td>24×48</td>
                <td>9.00</td>
                <td>2</td>
                <td>30</td>
                <td>15.50</td>
                <td>1.44</td>
                <td>66 + 30</td>
                <td>2000 + 910</td>
                <td>10 + 8</td>
                <td>900</td>
                <td>1296.00</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="container my-5" data-aos="fade-up">
        <h2 className="text-center mb-4 custom-font">GLAZE PORCELAIN TILES</h2>
        <div className="table-responsive">
          <table className="table table-bordered table-hover text-center align-middle">
            <thead className="table-dark">
              <tr>
                <th>Sr. No.</th>
                <th>Size (mm)</th>
                <th>Size (cm)</th>
                <th>Size (inch)</th>
                <th>Thickness (mm)</th>
                <th>Pcs/Box</th>
                <th>Box Weight (kg)</th>
                <th>Coverage (sq. ft.)</th>
                <th>Coverage (sq. mtr.)</th>
                <th>Box/Pallet</th>
                <th>Pallet Weight (kg)</th>
                <th>Pallet/Container</th>
                <th>Box/Container</th>
                <th>Sq. Mtr./Container</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>300×600</td>
                <td>30×60</td>
                <td>12×24</td>
                <td>9.00</td>
                <td>5</td>
                <td>18</td>
                <td>9.68</td>
                <td>0.90</td>
                <td>64</td>
                <td>1160</td>
                <td>24</td>
                <td>1536</td>
                <td>1382.40</td>
              </tr>
              <tr>
                <td>2</td>
                <td>300×600</td>
                <td>30×60</td>
                <td>12×24</td>
                <td>9.00</td>
                <td>8</td>
                <td>28</td>
                <td>15.50</td>
                <td>1.44</td>
                <td>40</td>
                <td>1130</td>
                <td>24</td>
                <td>960</td>
                <td>1382.40</td>
              </tr>
              <tr>
                <td>3</td>
                <td>600×600</td>
                <td>60×60</td>
                <td>24×24</td>
                <td>9.00</td>
                <td>4</td>
                <td>28</td>
                <td>15.50</td>
                <td>1.44</td>
                <td>40</td>
                <td>1130</td>
                <td>24</td>
                <td>960</td>
                <td>1382.40</td>
              </tr>
              <tr>
                <td>5</td>
                <td>600×1200</td>
                <td>60×120</td>
                <td>24×48</td>
                <td>9.00</td>
                <td>2</td>
                <td>30</td>
                <td>15.50</td>
                <td>1.44</td>
                <td>66 + 30</td>
                <td>2000 + 910</td>
                <td>10 + 8</td>
                <td>900</td>
                <td>1296.00</td>
              </tr>
              <tr>
                <td>6</td>
                <td>195×1200</td>
                <td>19.5×120</td>
                <td>8×48</td>
                <td>9.00</td>
                <td>6</td>
                <td>30</td>
                <td>15.10</td>
                <td>1.404</td>
                <td>36</td>
                <td>1090</td>
                <td>25</td>
                <td>900</td>
                <td>1263.60</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="container my-5" data-aos="fade-up">
        <h2 className="text-center mb-4 custom-font">
          POLISHED PORCELAIN TILES
        </h2>
        <div className="table-responsive">
          <table className="table table-bordered table-hover text-center align-middle">
            <thead className="table-dark">
              <tr>
                <th>Sr. No.</th>
                <th>Size (mm)</th>
                <th>Size (cm)</th>
                <th>Size (inch)</th>
                <th>Thickness (mm)</th>
                <th>Pcs/Box</th>
                <th>Box Weight (kg)</th>
                <th>Coverage (sq. ft.)</th>
                <th>Coverage (sq. mtr.)</th>
                <th>Box/Pallet</th>
                <th>Pallet Weight (kg)</th>
                <th>Pallet/Container</th>
                <th>Box/Container</th>
                <th>Sq. Mtr./Container</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>800×800</td>
                <td>80×80</td>
                <td>32×32</td>
                <td>9.00</td>
                <td>3</td>
                <td>38</td>
                <td>20.66</td>
                <td>1.92</td>
                <td>32</td>
                <td>1225</td>
                <td>22</td>
                <td>640</td>
                <td>1351.68</td>
              </tr>
              <tr>
                <td>2</td>
                <td>800×1600</td>
                <td>80×160</td>
                <td>32×64</td>
                <td>9.00</td>
                <td>2</td>
                <td>55</td>
                <td>27.56</td>
                <td>2.56</td>
                <td>40 + 10</td>
                <td>2230 + 560</td>
                <td>10 + 6</td>
                <td>460</td>
                <td>1177.60</td>
              </tr>
              <tr>
                <td>4</td>
                <td>1200×1200</td>
                <td>120×120</td>
                <td>48×48</td>
                <td>9.00</td>
                <td>2</td>
                <td>60</td>
                <td>30.98</td>
                <td>2.88</td>
                <td>26 + 20</td>
                <td>1580 + 1210</td>
                <td>12 + 4</td>
                <td>392</td>
                <td>1128.96</td>
              </tr>
              <tr>
                <td>5</td>
                <td>1200×2400 – with box (40 ft cont)</td>
                <td>120×240</td>
                <td>48×96</td>
                <td>9.00</td>
                <td>1</td>
                <td>62</td>
                <td>30.98</td>
                <td>2.88</td>
                <td>11</td>
                <td>700</td>
                <td>28</td>
                <td>308</td>
                <td>887.04</td>
              </tr>
              <tr>
                <td>6</td>
                <td>1200×2400 – without box (40 ft cont)</td>
                <td>120×240</td>
                <td>48×96</td>
                <td>9.00</td>
                <td>1</td>
                <td>62</td>
                <td>30.98</td>
                <td>2.88</td>
                <td>15</td>
                <td>950</td>
                <td>28</td>
                <td>420</td>
                <td>1209.60</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

// Tiles Classification Component
function TilesClassification() {
  return (
    <div className="container my-5">
      <h3 className="text-center mb-4" data-aos="fade-up">
        Tiles Classification
      </h3>

      {/* Content Row */}
      <div className="row">
        <div className="col-md-12" data-aos="fade-right">
          <p className="text-muted" style={{ fontSize: "1.6rem" }}>
            Tiles are classified based on size, finish, material, and usage.
          </p>
          <p
            className="text-muted "
            style={{ fontSize: "1.4rem", color: "black" }}
          >
            <strong>Common categories include:</strong>{" "}
          </p>
          <h5 className="text-primary">❖ Ceramic Tiles</h5>
          <h5 className="text-primary">❖ Glazed Vitrified Tiles (GVT)</h5>
          <h5 className="text-primary">❖ Double Charged Vitrified Tiles</h5>
          <h5 className="text-primary">❖ Full Body Vitrified Tiles</h5>
          <h5 className="text-primary">❖ Slab Tiles</h5>
          <h5 className="text-primary">❖ Parking Tiles / Outdoor Tiles</h5>

          <p className="text-muted mt-8" style={{ fontSize: "1.3rem" }}>
            Ceramic tiles are divided into groups according to their method of
            manufacture and water absorption. These groups do{" "}
            <strong>not</strong> determine how the tiles are to be used.
          </p>
          <p className="text-muted" style={{ fontSize: "1.3rem" }}>
            Both the <strong>International Standards Organization (ISO)</strong>{" "}
            and the <strong>European Standards (EN)</strong> classify ceramic
            tiles this way — based on manufacturing process and{" "}
            <strong>water absorption (E % by mass)</strong>.
          </p>
        </div>
      </div>

      {/* Table Image */}
      <div className="mt-5 text-center" data-aos="fade-up">
        <h4 className="mb-3"> Varay QC Services </h4>
        <img
          src="/images/Varay QC Services Inspection Table.jpg"
          alt="Inspection Table"
          className="img-fluid"
          style={{ maxWidth: "100%", height: "auto" }}
        />
      </div>
      <div className="container my-5">
        <h3 className="text-center mb-4" data-aos="fade-up">
          Market-Based Tile Classification
        </h3>
        <div className="row">
          <div className="col-12" data-aos="fade-right">
            <p className="text-muted" style={{ fontSize: "1.2rem" }}>
              <strong>
                According to market language for buy/sell product, tiles are
                classified by the following groups:
              </strong>
            </p>

            <div className="mb-4">
              <h5 className="text-primary">❖ Vitrified Tiles </h5>
              <p className="text-muted">
                Either unglazed or glazed and characterized by a low water
                absorption of less than <strong>0.5%</strong> (Class B Ia).
                These tiles are typically <strong>dry pressed</strong> and are
                known for their strength and durability.
              </p>
            </div>

            <div className="mb-4">
              <h5 className="text-primary">❖ Semi Vitrified Tiles </h5>
              <p className="text-muted">
                Available in unglazed or glazed formats and produced either by{" "}
                <strong>dry pressing</strong> or <strong>extruding</strong>.
                Classified into:
                <ul className="text-muted" style={{ fontSize: "1rem" }}>
                  <li>
                    ▪️ <strong>Vitrified Tiles</strong>: Class B Ib (dry
                    pressed), Class A I (extruded), water absorption between{" "}
                    <strong>0.5% – 3%</strong>.
                  </li>
                  <li>
                    ▪️ <strong>Semi-Vitrified Tiles</strong>: Class B IIa (dry
                    pressed), Class A IIa (extruded), water absorption between{" "}
                    <strong>3% – 6%</strong>.
                  </li>
                </ul>
                <em>
                  🔹 In simple market terms, these are often called{" "}
                  <strong>Ceramic Floor Tiles</strong>.
                </em>
              </p>
            </div>

            <div className="mb-4">
              <h5 className="text-primary">❖ Wall Tiles </h5>
              <p className="text-muted">
                These are primarily <strong>wall tiles</strong> with water
                absorption between <strong>10% – 20%</strong>, classified as{" "}
                <strong>B III</strong>. Typically glazed with a{" "}
                <em>gloss or satin finish</em> and suitable for indoor wall
                applications.
              </p>
            </div>

            <div className="mb-4">
              <h5 className="text-primary">❖ Glazed Vitrified Tiles </h5>
              <p className="text-muted">
                Combines technical strength of vitrified/porcelain body with
                glazed finish. Suitable for <strong>interior cladding</strong>.
                For <strong>external cladding in frost conditions</strong>, only
                tiles with <strong>&lt; 3% water absorption</strong> should be
                used.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Main Component
function Information() {
  const { topic } = useParams();

  let content;
  if (topic === "Packing Details") {
    content = <PackingDetails />;
  } else if (topic === "Tiles - Classification") {
    content = <TilesClassification />;
  } else {
    content = (
      <div className="container my-5">
        <h4 className="text-danger text-center">❌ Invalid Information Page</h4>
      </div>
    );
  }

  return (
    <div>
      <PageBanner title="Information" />
      {content}
    </div>
  );
}

export default Information;
